module.exports = __webpack_public_path__ + "static/media/bgNoDataHistoryDelivery.bf14d01b.png";